/* eslint react-hooks/exhaustive-deps: "warn" */
import { useEffect, useRef } from 'react';

import cn from 'classnames';

import { useInt } from 'hooks/useInt';

import { TitleBlock } from 'ui/atoms/TitleBlock/TitleBlock';
import { Section } from 'ui/molecules/Section/Section';

import styles from './CrmDataEnrichmentFeed.module.scss';

const FEED = [
  {
    date: '26 Jul 2026',
    company: 'Meridian Freight Ltd',
    change: 'changed registered address',
    field: 'address · Companies House',
  },
  {
    date: '24 Jul 2026',
    company: 'Calder Systems SA',
    change: 'filed FY2025 accounts',
    field: 'turnover, net assets',
  },
  {
    date: '22 Jul 2026',
    company: 'Aldermere Trading BV',
    change: 'new ultimate parent recorded',
    field: 'ownership · UBO register',
  },
  {
    date: '21 Jul 2026',
    company: 'Ravensworth Ltd',
    change: 'status moved to liquidation',
    field: 'status · gazette notice',
  },
  {
    date: '19 Jul 2026',
    company: 'Ostrand Logistik GmbH',
    change: 'legal name changed',
    field: 'legal name · Handelsregister',
  },
];

export const CrmDataEnrichmentFeed = () => {
  const { t } = useInt();

  const headRef = useRef<HTMLDivElement>(null);
  const rowRefs = useRef<(HTMLDivElement | null)[]>([]);

  useEffect(() => {
    const revealables = [headRef.current, ...rowRefs.current].filter((el): el is HTMLDivElement => Boolean(el));

    if (!revealables.length) {
      return undefined;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add(styles.revealed);
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15 },
    );

    revealables.forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  return (
    <Section background="#0E1526" theme="dark" className={styles.root}>
      <div ref={headRef} className={cn(styles.head, styles.reveal)}>
        <div className={styles.headTop}>
          <span className={styles.live}>
            <span className={styles.liveDot} />
            {t('Live')}
          </span>
        </div>
        <TitleBlock theme="dark" align="left" title={t('The record keeps itself honest.')} />
      </div>

      <div className={styles.card}>
        {FEED.map((item, i) => (
          <div
            key={item.company}
            ref={(el) => {
              rowRefs.current[i] = el;
            }}
            className={cn(styles.row, styles.reveal)}
            style={{ transitionDelay: `${i * 80}ms` }}
          >
            <div className={styles.rail}>
              <span className={styles.dot} />
              {i < FEED.length - 1 && <span className={styles.connector} />}
            </div>

            <span className={styles.date}>{item.date}</span>

            <div className={styles.body}>
              <span className={styles.company}>{item.company}</span>
              <span className={styles.change}>{item.change}</span>
            </div>

            <span className={styles.field}>{item.field}</span>
          </div>
        ))}
      </div>

      <p className={styles.note}>{t('Illustrative feed. Entities and dates are sample data.')}</p>
    </Section>
  );
};
